import React from 'react';
import marked from 'marked';
import { HeadlineTitle } from '../../components/Title';
import { SectionLayout } from '../../components/Layouts';
import { Row, Col } from '../../components/Grid';
import Image from '../../components/Image';

import * as S from './style';

const HowPeopleSpendAndEarn = ({
  bgcolor,
  isSpend,
  earnSectionTitle,
  earnSectionContnet,
  spendSectionTitle,
  spendSectionContnet,
}) => {
  return (
    <S.Wrapper>
      <SectionLayout id={isSpend ? 'how-spend-tc' : 'how-earn-tc'} bgcolor={bgcolor}>
        <Row>
          <Col w={[4, 6, 8]}>
            <HeadlineTitle color="white" lineColor="white" lightLine width="80%">
              {isSpend ? spendSectionTitle : earnSectionTitle}
            </HeadlineTitle>
            <S.TextsWrapper mt={5} mtM={4} fontSizeB={24} lineHeightB={32}>
              <div
                dangerouslySetInnerHTML={{
                  __html: isSpend ? marked(spendSectionContnet) : marked(earnSectionContnet),
                }}
              />
            </S.TextsWrapper>
          </Col>
        </Row>
      </SectionLayout>
      <S.ImageWrapper style={{ bottom: '2rem' }}>
        <Image image={isSpend ? 'ctaGallery' : 'ctaGardening'} />
      </S.ImageWrapper>
    </S.Wrapper>
  );
};

export default HowPeopleSpendAndEarn;
